'use client';
import MiniHome from '@/app/cms/common/uk-miniHome/miniHome';
import FloatBottomTips from '@/components/address/FloatBottomTips';
import DownloadBar from '@/components/header/components/downloadBar';
import MainHeader from '@/components/header/components/mainHeader';
import Mental from '@/components/header/components/mental';
import SearchBar from '@/components/header/components/searchBar';
import MainSideMenu from '@/components/headerFooter/header/components/mainSideMenu';
import HEADER_PAGE_TYPE from '@/constants/header';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
import { MentalObjectType } from '.';
import styles from './index.module.scss';
import { getShowDownloadBar } from './utils/downloadBarUtil';
import { useStores } from '../../models';
export interface IHeaderProps {
  pageType: keyof typeof HEADER_PAGE_TYPE; // 确保 `pageType` 的类型与 HEADER_PAGE_TYPE 的键一致
  disabled?: boolean;
  homeList?: any[];
  miniHomeModuleData?: any;
  poolData?: any;
  pathname?: string;
  mentalObject?: MentalObjectType;
  homeMentalObject?: MentalObjectType;
  pageCode?: string;
  pageName?: string;
}

const JDIHeader = observer(
  ({
    pageType = HEADER_PAGE_TYPE.NORMAL,
    disabled = false,
    homeList,
    miniHomeModuleData,
    poolData,
    pathname,
    mentalObject,
    homeMentalObject,
    pageCode,
    pageName,
  }: IHeaderProps) => {
    const pageConfig: Record<
      keyof typeof HEADER_PAGE_TYPE,
      {
        showDownloadBar: boolean;
        showMainHeader: boolean;
        showSearchBar: boolean;
        showLocationErrorTips: boolean;
        showMentalBar: boolean;
      }
    > = {
      [HEADER_PAGE_TYPE.HOME]: {
        showDownloadBar: true,
        showMainHeader: true,
        showSearchBar: true,
        showLocationErrorTips: true,
        showMentalBar: true,
      },
      [HEADER_PAGE_TYPE.MINIHOME]: {
        showDownloadBar: true,
        showMainHeader: true,
        showSearchBar: true,
        showLocationErrorTips: true,
        showMentalBar: true,
      },
      [HEADER_PAGE_TYPE.NORMAL]: {
        showDownloadBar: true,
        showMainHeader: true,
        showSearchBar: false,
        showLocationErrorTips: false,
        showMentalBar: false,
      },
      [HEADER_PAGE_TYPE.PROMOTION]: {
        // 券促页 包邮走这类 其他走NORMAL
        showDownloadBar: false,
        showMainHeader: true,
        showSearchBar: false,
        showLocationErrorTips: false,
        showMentalBar: false,
      },
    };
    const { isInJoybuyApp } = uaParse();
    const downloadBarRef = useRef(null); //下载楼层元素
    const mainHeaderRef = useRef(null); //头部楼层元素
    const mentalRef = useRef(null); //心智楼层元素
    const searchRef = useRef(null); //搜索楼层元素
    const miniHomeRef = useRef(null); //小首页楼层元素
    const showDownloadBar = getShowDownloadBar();
    const [isHideDownloadBar, setIsHideDownloadBar] = useState(!showDownloadBar); //是否隐藏下载楼层
    const [isShowMainSideMenu, setIsShowMainSideMenu] = useState(false); // 是否展示侧边菜单
    const [isScrollingUp, setIsScrollingUp] = useState<boolean>(false); //判断是否上滑
    const [isShowMental, setIsShowMental] = useState<boolean>(false); //是否显示吸顶心智
    const [miniHomeTop, setMiniHomeTop] = useState(0); //小首页距离顶部的高度
    const [mentalTop, setMentalTop] = useState(0); //心智距离顶部的高度
    const [currentTab, setCurrentTab] = useState(pageName);
    const { cartNumStore, userInfoStore } = useStores();

    useEffect(() => {
      let isThrottled = false;

      // 使用一个工具函数来获取元素高度
      const getHeight = (ref: React.RefObject<HTMLElement>) => ref.current?.offsetHeight || 0;
      const heights = {
        downloadBarHeight: (!isHideDownloadBar && getHeight(downloadBarRef)) || 0, //下载模块高度
        mainHeaderHeight: getHeight(mainHeaderRef), //主头部高度
        searchHeight: getHeight(searchRef), //搜索高度
        mentalRefHeight: getHeight(mentalRef), //心智模块高度
        miniHomeHeight: getHeight(miniHomeRef), //小首页高度
      };
      let lastScrollY = window.scrollY;
      const showHeight = heights.mainHeaderHeight + heights.searchHeight + heights.miniHomeHeight;

      let mentalTop = heights.mainHeaderHeight + heights.searchHeight; //心智吸顶高度
      const miniHomeTop = heights.mainHeaderHeight + heights.searchHeight; //小首页吸顶高度

      setMiniHomeTop(miniHomeTop);

      const handleScroll = () => {
        if (isThrottled) return;
        isThrottled = true;
        const currentScrollY = window.scrollY;

        //判断是否在小首页，如果是小首页就不受滚动方向影响
        if (pageType === HEADER_PAGE_TYPE.MINIHOME) {
          mentalTop = heights.mainHeaderHeight + heights.searchHeight + heights.miniHomeHeight;
        } else {
          //判断如果在首页时,根据滚动方向判断吸顶高度
          if (currentScrollY < lastScrollY) {
            setIsScrollingUp(true);
            mentalTop = heights.mainHeaderHeight + heights.searchHeight + heights.miniHomeHeight;
          } else {
            setIsScrollingUp(false);
            mentalTop = heights.mainHeaderHeight + heights.searchHeight;
          }
        }
        setMentalTop(mentalTop);
        lastScrollY = currentScrollY;
        //判断是否展示吸顶心智
        if (currentScrollY < showHeight) {
          setIsShowMental(false);
        } else {
          setIsShowMental(true);
        }

        setTimeout(() => {
          isThrottled = false;
        }, 10);
      };

      if (!disabled) window.addEventListener('scroll', handleScroll);
      return () => {
        if (!disabled) window.removeEventListener('scroll', handleScroll);
      };
    }, [isHideDownloadBar]);

    useEffect(() => {
      cartNumStore.fetchCartNum();
      userInfoStore.fetchUserInfo();
    }, [cartNumStore, userInfoStore]);

    const showObjs = pageConfig[pageType] || pageConfig[HEADER_PAGE_TYPE.NORMAL];
    return (
      <>
        <div id='header_v2'></div>
        {/* 下载楼层 */}
        {showObjs.showDownloadBar && !isInJoybuyApp && (
          <div className={styles.downloadBarWrapper} ref={downloadBarRef}>
            <DownloadBar
              isHideDownloadBar={isHideDownloadBar}
              setIsHideDownloadBar={setIsHideDownloadBar}
              pageCode={pageCode}
            />
          </div>
        )}
        {/* 主要头部楼层 */}
        {showObjs.showMainHeader && (
          <MainHeader
            mainHeaderRef={mainHeaderRef}
            setIsShowMainSideMenu={setIsShowMainSideMenu}
            disabled={disabled}
            pageCode={pageCode}
          />
        )}
        {/* 心智楼层 */}
        {showObjs.showMentalBar && !disabled && (
          <Mental
            mentalRef={mentalRef}
            disabled={disabled}
            mentalObject={mentalObject}
            homeMentalObject={homeMentalObject}
            isShowMental={isShowMental}
            mentalTop={mentalTop}
            currentTab={currentTab}
            pageName={pageName}
          />
        )}

        {/* 搜索楼层 */}
        {showObjs.showSearchBar && !disabled && (
          <SearchBar
            disabled={disabled}
            searchRef={searchRef}
            miniHomeModuleData={miniHomeModuleData}
            poolData={poolData}
            pageCode={pageCode}
            pageType={pageType}
          />
        )}
        {/* minihome */}
        {homeList && homeList.length !== 0 && !disabled && (
          <MiniHome
            pageCode={pageCode || ''}
            pathname={pathname}
            pageType={pageType}
            List={homeList}
            moduleData={miniHomeModuleData}
            isScrollingUp={isScrollingUp}
            miniHomeTop={miniHomeTop}
            miniHomeRef={miniHomeRef}
            setCurrentTab={setCurrentTab}
          />
        )}
        {/* 侧边菜单 */}
        {isShowMainSideMenu && (
          <MainSideMenu
            accountData={userInfoStore?.accountData}
            setIsShowMainSideMenu={setIsShowMainSideMenu}
          />
        )}

        {/* 底部提示 */}
        {showObjs.showLocationErrorTips && <FloatBottomTips />}
      </>
    );
  },
);

export default JDIHeader;
